<div class="user-card-container" ngbDropdown #profileDrop="ngbDropdown">
  <div class="user-card" id="userCard" ngbDropdownToggle>
    <kendo-avatar [initials]="user.initials">{{user.initials}}</kendo-avatar>
    
  </div>
  <div ngbDropdownMenu aria-labelledby="userCard">
    <div class="user-details">
      <h2>{{ user.fullName }}</h2>
      <p>{{user.companyName}}</p>
    </div>
    <div class="dd-menu-separator"></div>
    <div class="dd-menu-header">User Details</div>
    <!--<button class="dd-menu-item" (click)="showProfileModal()" ngbDropdownItem>User Profile</button>-->
    <button class="dd-menu-item" (click)="showSettingsModal()" ngbDropdownItem>Settings</button>
    <div class="dd-menu-separator"></div>
    <button class="dd-menu-item" ngbDropdownItem (click)="logout()">Log Out</button>
  </div>
</div>
